import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../EnachCard.module.scss';
import { ENACHStatus } from './const';
import { AlertIcon } from '@navi/web-ui/lib/icons';

const AutopayExpired = () => {
  return (
    <>
      <div className={styles.enachCardErrorIcon}>
        <AlertIcon color={'var(--orange-dark)'} />
      </div>

      <div className={styles.enachCardFailureReason}>
        <Typography
          variant="p3"
          color={'var(--orange-dark)'}
          className={styles.enachFailureReasonText}
        >
          {ENACHStatus.AutopayExpired}
        </Typography>
      </div>
    </>
  );
};

export default AutopayExpired;
